import {
  instance,
  instanceNoErr
} from '@/common/api.js';

const apiServe = instance;
const apiServeNoerr = instanceNoErr;
export const getCode = (data) => {
  return apiServe({
    url: '/wechat/captcha',
    method: 'post',
    data
  });
};

// 微信登陆
export const LoginByWeChat = data => {
  return apiServe({
    url: '/wechat/auth',
    method: 'post',
    data
  });
};

// 获取来访事由
export const getReasons = data => {
  return apiServe({
    url: '/wechat/invite-settings',
    method: 'post',
    data
  });
};

// 绑定用户
export const onBind = data => {
  return apiServe({
    url: '/wechat/visitor/bind',
    method: 'post',
    data
  });
};

// 绑定用户
export const bindByStaff = data => {
  return apiServe({
    url: '/wechat/staff/register',
    method: 'post',
    data
  });
};

// 访客绑定微信的填写字段
export const fieldsByVisitor = data => {
  return apiServe({
    url: '/wechat/register/fields',
    method: 'post',
    data
  });
};

// 访客预约
export const Appointment = data => {
  return apiServeNoerr({
    url: '/wechat/visitor/appointment',
    method: 'post',
    data
  });
};

// 邀约访客
export const Invite = data => {
  return apiServeNoerr({
    url: '/wechat/staff/invite',
    method: 'post',
    data
  });
};

// 查询被访人
export const searchStaff = data => {
  return apiServeNoerr({
    url: '/wechat/staff/search',
    method: 'post',
    data
  });
};

// 根据手机号查询员工（用于访客预约）
export const searchAppointment = data => {
  return apiServeNoerr({
    url: '/wechat/staff/search/appointment',
    method: 'post',
    data
  });
};

// 上传头像
export const upload = data => {
  return apiServe({
    url: '/wechat/image/upload',
    method: 'post',
    data
  });
};

// 员工认证
export const staffCertification = data => {
  return apiServe({
    url: '/wechat/staff/certification',
    method: 'post',
    data
  });
};

// 邀约信息
export const inviteInfo = data => {
  return apiServe({
    url: '/wechat/guest/invite/info/v2',
    method: 'post',
    data
  });
};

// 刷新二维码(已弃用)
export const refreshCode = data => {
  return apiServe({
    url: '/wechat/guest/invite/qrcode/refresh',
    method: 'post',
    data
  });
};

// 取消预约
export const cancelAppointment = data => {
  return apiServe({
    url: '/wechat/visitor/appointment/operate',
    method: 'post',
    data
  });
};

// 授权人脸通行
export const faceAuth = data => {
  return apiServe({
    url: '/wechat/guest/face/auth',
    method: 'post',
    data
  });
};

// 获取微信公众号的调用JSAPI的配置
export const wechatSignature = data => {
  return apiServe({
    url: '/wechat/signature',
    method: 'post',
    data
  });
};

// 取消访问/结束访问
export const inviteOperate = data => {
  return apiServe({
    url: '/wechat/guest/invite/operate',
    method: 'post',
    data
  });
};

// 更新用户头像
export const faceUpdate = data => {
  return apiServe({
    url: '/wechat/visitor/faceimg/update',
    method: 'post',
    data
  });
};
